// LICENSE : MIT
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AlminLogger = require("./AlminLogger");

var _AlminLogger2 = _interopRequireDefault(_AlminLogger);

var _LogGroup = require("./log/LogGroup");

var _LogGroup2 = _interopRequireDefault(_LogGroup);

var _LogChunk = require("./log/LogChunk");

var _LogChunk2 = _interopRequireDefault(_LogChunk);

var _PrintLogger = require("./log/PrintLogger");

var _PrintLogger2 = _interopRequireDefault(_PrintLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var EventEmitter = require("events");
var Map = require("map-like");
// FIXME: Almin 0.12 support pull-based Store
// https://github.com/almin/almin/pull/154
// Some Store must to have prevState arguments.
// Call ths Store without argument, throw error
var tryGetState = function tryGetState(store) {
    try {
        return store.getState();
    } catch (error) {
        return null; // not get
    }
};
/**
 * Pattern
 *
 * AUseCase will
 * AUseCase did
 * AUseCase complete => output
 *
 * --------
 *
 * AUseCase will
 *  CUseCase will
 *  CUseCase did
 * AUseCase did
 * CUseCase Complete
 * AUseCase Complete
 *
 */

var AsyncLogger = function (_EventEmitter) {
    _inherits(AsyncLogger, _EventEmitter);

    /**
     * @param {Object} console
     */
    function AsyncLogger(_ref) {
        var console = _ref.console;

        _classCallCheck(this, AsyncLogger);

        /**
         * Will show log buffer
         * @type {MapLike[]}
         * @private
         */
        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        _this._currentLogBuffer = [];
        /**
         * @type {MapLike}
         */
        _this._logMap = new Map();
        _this._releaseHandlers = [];
        /**
         * @type {Console|Object|*}
         */
        _this.logger = console;
        _this.printLogger = new _PrintLogger2.default(_this.logger);
        return _this;
    }

    /**
     * start logging for {@link context}
     * @param {Context} context
     */


    AsyncLogger.prototype.startLogging = function startLogging(context) {
        var _this2 = this;

        /**
         * @param {WillExecutedPayload} payload
         * @param {DispatcherPayloadMeta} meta
         */
        var onWillExecuteEachUseCase = function onWillExecuteEachUseCase(payload, meta) {
            var useCase = meta.useCase;
            var parentUseCase = meta.parentUseCase !== useCase ? meta.parentUseCase : null;
            var parentSuffix = parentUseCase ? " <- " + parentUseCase.name : "";
            var title = "" + useCase.name + parentSuffix;
            var logGroup = new _LogGroup2.default({ title: title, useCaseName: useCase.name });
            var args = payload.args.length && payload.args.length > 0 ? payload.args : undefined;
            var log = [useCase.name + " execute:"].concat(args);
            logGroup.addChunk(new _LogChunk2.default({
                useCase: useCase,
                payload: payload,
                log: log,
                timeStamp: meta.timeStamp
            }));
            if (parentUseCase) {
                var parentLogMap = _this2._logMap.get(parentUseCase);
                parentLogMap.addGroup(logGroup);
            }
            _this2._logMap.set(useCase, logGroup);
            if (!parentUseCase) {
                // if logGroup is of root
                _this2._currentLogBuffer.push(logGroup);
            }
        };
        /**
         *
         * @param {Payload} payload
         * @param {DispatcherPayloadMeta} meta
         */
        var onDispatch = function onDispatch(payload, meta) {
            var useCase = meta.useCase;
            if (!useCase) {
                _this2.addLog(["\uD83D\uDD25 Dispatch:" + String(payload.type), payload]);
                return;
            }
            var logGroup = _this2._logMap.get(useCase);
            // http://emojipedia.org/fire/
            logGroup.addChunk(new _LogChunk2.default({
                useCase: useCase,
                payload: payload,
                log: [useCase.name + " dispatch:" + String(payload.type), payload],
                timeStamp: meta.timeStamp
            }));
        };
        var onChangeStores = function onChangeStores(changeStores) {
            // one, or more stores
            var stores = [].concat(changeStores);
            var useCases = _this2._logMap.keys();
            var workingUseCaseNames = useCases.map(function (useCase) {
                return useCase.name;
            });
            // if Store#emitChange is called by async, workingUseCaseNames.length is 0.
            var existWorkingUseCase = workingUseCaseNames.length !== 0;
            if (existWorkingUseCase) {
                // It support Almin's QueuedStoreGroup implementation
                stores.forEach(function (store) {
                    var state = tryGetState(store);
                    _this2.addLog(["\uD83D\uDCBE Store:" + store.name, state !== null ? state : store]);
                    if (workingUseCaseNames.length >= 2) {
                        _this2.addLog("\u2139\uFE0F Currently executing UseCases: " + workingUseCaseNames.join(", "));
                    }
                });
            } else {
                // It support Almin's StoreGroup implementation.
                // StoreGroup emit change after UseCase is completed
                var storeLogGroup = new _LogGroup2.default({
                    title: "Store is changed"
                });
                var timeStamp = Date.now();
                stores.forEach(function (store) {
                    var state = tryGetState(store);
                    storeLogGroup.addChunk(new _LogChunk2.default({
                        log: ["\uD83D\uDCBE Store:" + store.name, state !== null ? state : store],
                        timeStamp: timeStamp
                    }));
                });
                _this2.printLogger.printLogGroup(storeLogGroup);
            }
        };
        /**
         * @param {ErrorPayload} payload
         * @param {DispatcherPayloadMeta} meta
         */
        var onErrorHandler = function onErrorHandler(payload, meta) {
            // if has useCase and group by useCase
            var error = payload.error || "Something wrong";
            var useCase = meta.useCase;
            var logGroup = _this2._logMap.get(useCase);
            logGroup.addChunk(new _LogChunk2.default({
                log: [useCase.name + " throw Error:", error],
                payload: payload,
                useCase: useCase,
                timeStamp: meta.timeStamp
            }));
        };
        /**
         * @param {DidExecutedPayload} payload
         * @param {DispatcherPayloadMeta} meta
         */
        var onDidExecuteEachUseCase = function onDidExecuteEachUseCase(payload, meta) {
            var useCase = meta.useCase;
            var resultValue = meta.value;
            var logGroup = _this2._logMap.get(useCase);
            logGroup.addChunk(new _LogChunk2.default({
                useCase: useCase,
                payload: payload,
                log: [useCase.name + " did executed:", resultValue],
                timeStamp: meta.timeStamp
            }));
        };
        /**
         * @param {CompletedPayload} payload
         * @param {DispatcherPayloadMeta} meta
         */
        var onCompleteUseCase = function onCompleteUseCase(payload, meta) {
            var useCase = meta.useCase;
            var resultValue = meta.value;
            var logGroup = _this2._logMap.get(useCase);
            logGroup.addChunk(new _LogChunk2.default({
                useCase: useCase,
                payload: payload,
                log: [useCase.name + " is completed:", resultValue],
                timeStamp: meta.timeStamp
            }));
            var index = _this2._currentLogBuffer.indexOf(logGroup);
            if (index !== -1) {
                _this2._currentLogBuffer.splice(index, 1);
                _this2.printLogger.printLogGroup(logGroup);
                _this2.emit(_AlminLogger2.default.Events.output, logGroup);
            }
            _this2._logMap.delete(useCase);
        };
        // release handler
        this._releaseHandlers = [context.onChange(onChangeStores), context.onDispatch(onDispatch), context.onWillExecuteEachUseCase(onWillExecuteEachUseCase), context.onDidExecuteEachUseCase(onDidExecuteEachUseCase), context.onCompleteEachUseCase(onCompleteUseCase), context.onErrorDispatch(onErrorHandler)];
    };

    /**
     * add log to logger
     * @param {*} log
     */


    AsyncLogger.prototype.addLog = function addLog(log) {
        var _this3 = this;

        var useCases = this._logMap.keys();
        useCases.forEach(function (useCase) {
            var logGroup = _this3._logMap.get(useCase);
            logGroup.addChunk(new _LogChunk2.default({
                log: log,
                timeStamp: Date.now()
            }));
        });
    };

    /**
     * flush current log buffer
     */


    AsyncLogger.prototype.flushBuffer = function flushBuffer() {
        this._logMap.clear();
    };

    /**
     * release event handlers
     */


    AsyncLogger.prototype.release = function release() {
        this._releaseHandlers.forEach(function (releaseHandler) {
            return releaseHandler();
        });
        this._releaseHandlers.length = 0;
        this._logMap.clear();
    };

    return AsyncLogger;
}(EventEmitter);

exports.default = AsyncLogger;
module.exports = exports["default"];
//# sourceMappingURL=AsyncLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./~/almin-logger/lib/AsyncLogger.js
// module id = 229
// module chunks = 0